module.exports = __webpack_public_path__ + "static/media/triangle.b2d294e0.svg";